<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AaFK1f/tc-custom/9781504084901.jpg?1728259255726" alt="This image is the cover for the book Liberated, The Kaspar Brothers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Liberated, The Kaspar Brothers
      </h1>
      <p class="bookDescription body article font2">
        <b>An American captain in post-WWII Germany must stop a criminal conspiracy by his fellow officers in this historical thriller by the author of <i>The Losing Role</i>.</b><br/>  <br/><i>Germany, May, 1945</i>. With the war just over, Capt. Harry Kaspar is about to take a new posting in the US occupation—running a Bavarian town named Heimgau. When Harry loses the command to a rival, he’ll do almost anything to win the job back. <br/>  <br/> Then Harry discovers a horrific scene: three German men tortured and murdered. Solving the crime could teach the locals about American justice—and help him reclaim his posting. But as Harry’s quest for the killer leads him back to American officers, he uncovers a criminal network plundering the war-torn land for all its worth. Now, for justice to mean anything at all, Harry must fight back.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Steve Anderson
      </h2>
      
      <p class="authorDescription body article"> Steve Anderson&#160;is the author of the Kaspar Brothers novels:&#160;<I>The Losing Role</I>,&#160;<I>Liberated</I>, and&#160;<I>Lost Kin</I>.&#160;<I>Under False Flags&#160;</I>is the prequel to his latest novel&#160;<I>The Preserve</I>. Anderson was a Fulbright Fellow in Germany and is a literary translator of bestselling German fiction as well as a freelance editor. He lives in Portland, Oregon.&#160; </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Yucca Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0e74e4b4